var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { TypeActionOngoingPurchaseInfo } from "./actionOngoingPurchase";
import { IdPurchaseType } from "./IdPurchaseType";
var premiumInitialState = {
    isConfirmed: false,
};
var initial = {
    characterHelp: undefined,
    premium: premiumInitialState,
    quickSkipProcessId: undefined,
    standard: [],
};
export var reducerOngoingPurchase = function (state, action) {
    if (state === void 0) { state = initial; }
    switch (action.type) {
        case TypeActionOngoingPurchaseInfo.SelectPremium:
            return reducerOngoingPurchasePremiumSelect(state, action.premiumInfo);
        case TypeActionOngoingPurchaseInfo.SelectStandard:
            return reducerOngoingPurchaseStandardSelect(state, action.standardInfo);
        case TypeActionOngoingPurchaseInfo.SelectCharacterHelp:
            return reducerOngoingPurchaseCharacterHelpSelect(state, action.characterHelpInfo);
        case TypeActionOngoingPurchaseInfo.SelectSkipProcess:
            return reducerOngoingPurchaseSkipProcessSelect(state, action.skipProcess);
        case TypeActionOngoingPurchaseInfo.DeselectPremium:
            return reducerOngoingPurchasePremiumDeselect(state);
        case TypeActionOngoingPurchaseInfo.DeselectStandard:
            return reducerOngoingPurchaseStandardDeselect(state);
        case TypeActionOngoingPurchaseInfo.DeselectCharacterHelp:
            return reducerOngoingPurchaseCharacterHelpDeselect(state);
        case TypeActionOngoingPurchaseInfo.DeselectSkipProcess:
            return reducerOngoingPurchaseSkipProcessDeselect(state);
        case TypeActionOngoingPurchaseInfo.CloseAll:
            return reducerOngoingPurchaseCloseAll(state);
        default:
            return state;
    }
};
var reducerOngoingPurchasePremiumSelect = function (state, premiumInfo) {
    var _a;
    return __assign({}, state, (_a = {}, _a[IdPurchaseType.premium] = __assign({}, premiumInfo), _a));
};
var reducerOngoingPurchaseStandardSelect = function (state, standardInfo) {
    var _a;
    return __assign({}, state, (_a = {}, _a[IdPurchaseType.standard] = standardInfo.slice(), _a));
};
var reducerOngoingPurchasePremiumDeselect = function (state) {
    var _a;
    return __assign({}, state, (_a = {}, _a[IdPurchaseType.premium] = premiumInitialState, _a));
};
var reducerOngoingPurchaseStandardDeselect = function (state) {
    var _a;
    var standardInfo = state.standard || [];
    standardInfo.shift();
    return __assign({}, state, (_a = {}, _a[IdPurchaseType.standard] = standardInfo, _a));
};
var reducerOngoingPurchaseCloseAll = function (state) {
    return initial;
};
var reducerOngoingPurchaseCharacterHelpSelect = function (state, characterHelpInfo) {
    return __assign({}, state, { characterHelp: characterHelpInfo });
};
var reducerOngoingPurchaseCharacterHelpDeselect = function (state) {
    return __assign({}, state, { characterHelp: undefined });
};
var reducerOngoingPurchaseSkipProcessSelect = function (state, skipProcess) { return (__assign({}, state, { quickSkipProcessId: skipProcess })); };
var reducerOngoingPurchaseSkipProcessDeselect = function (state) { return (__assign({}, state, { quickSkipProcessId: undefined })); };



//////////////////
// WEBPACK FOOTER
// ./src/features/ongoing-purchase/reducerOngoingPurchase.ts
// module id = 2966
// module chunks = 3